import React, { useState, useEffect } from "react";
import { useParams } from "react-router-dom";
import api from "../../../utils/apiConfig";
import { Tab } from "@headlessui/react";
import {
  Chart as ChartJS,
  ArcElement,
  Tooltip,
  Legend,
  CategoryScale,
  LinearScale,
  BarElement,
} from "chart.js";
import { Pie, Bar } from "react-chartjs-2";
import SubPageLayout from "../../../components/shared/SubPageLayout";

import logger from '../../../utils/logger';

const EstatePlanning = () => {
  const { householdId } = useParams();
  const [household, setHousehold] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const fetchHouseholdData = async () => {
      try {
        const response = await api.get(
          `/advisor-portal/client-database/household-profile/${householdId}`,
        );
        setHousehold(response.data);
      } catch (err) {
        logger.error("Error fetching household data:", err);
      } finally {
        setLoading(false);
      }
    };

    fetchHouseholdData();
  }, [householdId]);

  if (loading) {
    return (
      <SubPageLayout
        title="Loading..."
        subtitle="View household estate planning"
        breadcrumbItems={[
          { label: "Advisor Portal", path: "/advisor-portal" },
          { label: "Client Database", path: "/advisor-portal/client-database" },
          {
            label: "Household Profile",
            path: `/advisor-portal/client-database/household-profile/${householdId}`,
          },
          {
            label: "Estate Planning",
            path: `/advisor-portal/client-database/household-profile/${householdId}/estate-planning`,
          },
        ]}
      >
        <div className="text-center py-4">Loading...</div>
      </SubPageLayout>
    );
  }

  return (
    <SubPageLayout
      title={`${household?.members[0]?.lastName || "Household"} Estate Planning`}
      subtitle="View household estate planning"
      breadcrumbItems={[
        { label: "Advisor Portal", path: "/advisor-portal" },
        { label: "Client Database", path: "/advisor-portal/client-database" },
        {
          label: "Household Profile",
          path: `/advisor-portal/client-database/household-profile/${householdId}`,
        },
        {
          label: "Estate Planning",
          path: `/advisor-portal/client-database/household-profile/${householdId}/estate-planning`,
        },
      ]}
    >
      <div className="bg-surface-default dark:bg-surface-default p-6 rounded-lg shadow">
        {/* Content will be added later */}
      </div>
    </SubPageLayout>
  );
};

export default EstatePlanning;
